<c-modal #staticBackdropModal backdrop="static" size="lg" visible='true' id="staticBackdropModal">
    <c-modal-header>
        <h4 class="modal-title">{{ "QR Code Detail" }}</h4>
        <button [cModalToggle]="staticBackdropModal.id" cButtonClose (click)="closeModal()" title="Close"></button>
    </c-modal-header>
    <c-modal-body>
        <c-row>
            <form cForm class="animate" (ngSubmit)="saveQRCode()" [formGroup]="qrCodeDetailForm">
              <c-row *ngIf="!isNew" >
                <c-col [md]="3">
                </c-col>
                <c-col [md]="8">
                  <qrcode 
                    elementType="img"
                    (qrCodeURL)="onChangeURL($event)" [qrdata]="qrData" [width]="250" [errorCorrectionLevel]="'M'" #qrCodeElement>
                  </qrcode>
                  <!-- <a [href]="qrCodeDownloadLink" download="angularx-qrcode">Download</a> -->
                  <button type="button" cButton color="primary" (click)="downloadHighResQRCode()">Download QR Code</button>
                </c-col>
              </c-row>
              <c-row *ngIf="!isNew" >
                <c-col [md]="3">
                </c-col>
                <c-col [md]="8">
                  <button *ngIf="!isNew" cButton color="link" (click)="copyToClipboard()">{{qrData}}</button>
                  <!-- <button *ngIf="!isNew && this.selectedQRCode.shortUrl != null && selectedQRCode.shortUrl != 'null'" cButton color="link" (click)="copyToClipboard()">{{selectedQRCode.shortUrl}}</button>
                  <button *ngIf="!isNew && !(this.selectedQRCode.shortUrl != null && selectedQRCode.shortUrl != 'null')" cButton color="link" (click)="copyToClipboard()">{{selectedQRCode.originalUrl}}</button> -->
                  <!-- Feedback message -->
                  <div *ngIf="showCopiedMessage" class="copied-message">Copied to clipboard!</div>
                </c-col>
              </c-row>
              <c-row>
                <c-col [md]="3">
                  <label cLabel for="message">
                    {{"Pet"}}
                  </label>
                </c-col>
                <c-col [md]="8">
                  <input
                      formControlName="petName" name="petName" type="text" id="petName"
                      cFormControl
                      placeholder="Select pet"
                      [typeaheadOptionsLimit]="10"
                      [typeaheadLatinize]="true"
                      [typeahead]="availablePets"
                      typeaheadOptionField="name"
                      [typeaheadMinLength]="0"
                      (typeaheadOnSelect)="onSelectPet($event)"
                    />
                  <!-- <input cFormControl formControlName="message" name="message" type="text" class="form-control" id="message" /> -->
                  <!-- <textarea cFormControl formControlName="message" name="message" class="form-control" id="message" title="Message" rows="3"></textarea> -->
                  <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!qrCodeDetailForm.controls['petName'].valid && !qrCodeDetailForm.controls['petName'].untouched">
                      {{ "Pet is required" }}
                  </div>
                </c-col>
              </c-row>
              <c-row>
                <c-col [md]="3">
                  <label cLabel for="ownerFirstName">
                    {{"Owner First Name"}}
                  </label>
                </c-col>
                <c-col [md]="8">
                  <input cFormControl formControlName="ownerFirstName" name="ownerFirstName" type="text" class="form-control" id="ownerFirstName" />
                  <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!qrCodeDetailForm.controls['ownerFirstName'].valid && !qrCodeDetailForm.controls['ownerFirstName'].untouched">
                      {{ "Owner first name is required" }}
                  </div>
                </c-col>
              </c-row>
              <c-row>
                <c-col [md]="3">
                  <label cLabel for="ownerLastName">
                    {{"Owner Last Name"}}
                  </label>
                </c-col>
                <c-col [md]="8">
                  <input cFormControl formControlName="ownerLastName" name="ownerLastName" type="text" class="form-control" id="ownerLastName" />
                  <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!qrCodeDetailForm.controls['ownerLastName'].valid && !qrCodeDetailForm.controls['ownerLastName'].untouched">
                      {{ "Owner last name is required" }}
                  </div>
                </c-col>
              </c-row>
              <c-row>
                <c-col [md]="3">
                    <label cLabel for="message">{{
                        "Message"
                        }}</label>
                </c-col>
                <c-col [md]="8">
                  <div class="editor">
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                    </ngx-editor-menu>
                    <ngx-editor [editor]="editor" formControlName="message" height="auto" minHeight="500px">
                    </ngx-editor>
                  </div>

                  <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!qrCodeDetailForm.controls['message'].valid && !qrCodeDetailForm.controls['message'].untouched">
                      {{ "Message is required" }}
                  </div>
                </c-col>
              </c-row>
              <c-row>
                <c-col [md]="3">
                  <label cLabel for="shortUrl">
                    {{"Short URL"}}
                  </label>
                </c-col>
                <c-col [md]="8">
                  <input cFormControl formControlName="shortUrl" name="shortUrl" type="text" class="form-control" id="shortUrl" />
                  <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!qrCodeDetailForm.controls['shortUrl'].valid && !qrCodeDetailForm.controls['shortUrl'].untouched">
                      {{ "short URL is required" }}
                  </div>
                </c-col>
              </c-row>
              <c-row>
                <c-col [md]="3">
                  <h5>Showing Fields</h5>
                </c-col>
              </c-row>
              <!-- Pet Image -->
              <c-row>
                <c-col [md]='3'>
                </c-col>
                <c-col [md]='8'>
                  <c-form-check [inline]="true">
                    <input cFormCheckInput  formControlName="isSharePetImage" id="isSharePetImage" type="checkbox" />
                    <label cFormCheckLabel for="isSharePetImage">Pet image</label>
                  </c-form-check>
                </c-col>
              </c-row>

              <!-- Pet Name -->
              <c-row>
                <c-col [md]='3'>
                </c-col>
                <c-col [md]='8'>
                  <c-form-check [inline]="true">
                    <input cFormCheckInput  formControlName="isSharePetName" id="isSharePetName" type="checkbox" />
                    <label cFormCheckLabel for="isSharePetName">Pet name</label>
                  </c-form-check>
                </c-col>
              </c-row>
              
              <!-- Pet Gender -->
              <c-row>
                <c-col [md]='3'>
                </c-col>
                <c-col [md]='8'>
                  <c-form-check [inline]="true">
                    <input cFormCheckInput  formControlName="isSharePetGender" id="isSharePetGender" type="checkbox" />
                    <label cFormCheckLabel for="isSharePetGender">Pet gender</label>
                  </c-form-check>
                </c-col>
              </c-row>

              <!-- Owner First Name -->
              <c-row>
                <c-col [md]='3'>
                </c-col>
                <c-col [md]='8'>
                  <c-form-check [inline]="true">
                    <input cFormCheckInput  formControlName="isShareOwnerFirstName" id="isShareOwnerFirstName" type="checkbox" />
                    <label cFormCheckLabel for="isShareOwnerFirstName">Owner First Name</label>
                  </c-form-check>
                </c-col>
              </c-row>

              <!-- Owner Last Name -->
              <c-row>
                <c-col [md]='3'>
                </c-col>
                <c-col [md]='8'>
                  <c-form-check [inline]="true">
                    <input cFormCheckInput  formControlName="isShareOwnerLastName" id="isShareOwnerLastName" type="checkbox" />
                    <label cFormCheckLabel for="isShareOwnerLastName">Owner Last Name</label>
                  </c-form-check>
                </c-col>
              </c-row>

              <!-- Owner Phone -->
              <c-row>
                <c-col [md]='3'>
                </c-col>
                <c-col [md]='8'>
                  <c-form-check [inline]="true">
                    <input cFormCheckInput  formControlName="isShareOwnerPhone" id="isShareOwnerPhone" type="checkbox" />
                    <label cFormCheckLabel for="isShareOwnerPhone">Owner Phone</label>
                  </c-form-check>
                </c-col>
              </c-row>

              <!-- Owner Email -->
              <c-row>
                <c-col [md]='3'>
                </c-col>
                <c-col [md]='8'>
                  <c-form-check [inline]="true">
                    <input cFormCheckInput  formControlName="isShareOwnerEmail" id="isShareOwnerEmail" type="checkbox" />
                    <label cFormCheckLabel for="isShareOwnerEmail">Owner Email</label>
                  </c-form-check>
                </c-col>
              </c-row>

              <!-- Owner Emergency Contact -->
              <c-row>
                <c-col [md]='3'>
                </c-col>
                <c-col [md]='8'>
                  <c-form-check [inline]="true">
                    <input cFormCheckInput  formControlName="isShareOwnerEmergencyContact" id="isShareOwnerEmergencyContact" type="checkbox" />
                    <label cFormCheckLabel for="isShareOwnerEmergencyContact">Owner Emergency Contact</label>
                  </c-form-check>
                </c-col>
              </c-row>
            </form>
        </c-row>
    </c-modal-body>
    <c-modal-footer>
      <button type="button" cButton color="secondary" (click)="closeModal()">Close</button>
      <button *ngIf="(!isNew && hasEditPermission) || (isNew && hasAddPermission)" type="button" cButton color="primary" (click)="saveQRCode()">
        <c-spinner aria-hidden="true" size="sm" hidden="!isSavingCheckOut"></c-spinner>Submit
      </button>
    </c-modal-footer>
</c-modal>
